import { getParentSaleLines } from '@/components/pos/posCart'
import { formatReceiptDateTime } from '@/components/pos/posReceipt'

/**
 * @param {import('@/types/api').PosServiceSlips | null | undefined} document
 */
export function canPrintServiceSlips(document) {
  return Boolean(document?.slips?.length)
}

/**
 * @param {import('@/types/api').Sale | null | undefined} sale
 */
export function canPrintServiceSlipsFromSale(sale) {
  return getParentSaleLines(sale).length > 0
}

/**
 * @param {import('@/types/api').PosServiceSlips | null | undefined} document
 */
export function getServiceSlipGuestLabel(document) {
  return document?.customer?.name ?? 'Walk-in'
}

/**
 * @param {string | null | undefined} status
 */
export function formatServiceLineStatus(status) {
  if (!status) return '—'
  return status.replace(/_/g, ' ')
}

/**
 * @param {import('@/types/api').PosServiceSlipLine} line
 */
export function formatServiceSlipLineSummary(line) {
  const duration = line.duration > 0 ? `${line.duration} min` : null
  const parts = [line.description]
  if (duration) parts.push(duration)
  if (line.split_percent) parts.push(`${line.split_percent}%`)
  return parts.join(' · ')
}

/**
 * @param {HTMLElement | null | undefined} node
 */
export function printServiceSlips(node) {
  if (!node) return

  document.body.classList.add('printing-service-slip')
  window.print()
  window.addEventListener('afterprint', () => {
    document.body.classList.remove('printing-service-slip')
  }, { once: true })
}

/**
 * @param {import('@/types/api').PosServiceSlips | null | undefined} document
 */
export function formatServiceSlipTicketTime(document) {
  const iso = document?.sale?.completed_at ?? document?.sale?.opened_at
  return formatReceiptDateTime(iso)
}
